import { h } from 'vue';
import DocumentContentClamped from '@/modules/document/components/DocumentContentClamped.vue';
import StickerCell from '@/modules/viewer/components/table-view/cells/StickerCell.vue';
import type { DocumentStatus } from '@/modules/document/types/document-status.type.ts';
import type { Document } from '@/modules/document/types/document.type.ts';
import DocumentActive from '@/modules/document/components/DocumentActive.vue';

export class DocumentCellsUtil {
  static content(value: Document) {
    return h(DocumentContentClamped, { text: value.content, mask: value.type.mask, onlyMouse: true });
  }

  static status(value: DocumentStatus) {
    return h(StickerCell, { text: value.name, color: value.color, size: 's' });
  }

  static active(value: boolean) {
    return value ? h(DocumentActive) : '';
  }
}
